import { render, staticRenderFns } from "./KaufschutzRateEdit.vue?vue&type=template&id=7b21d8ba&"
import script from "./KaufschutzRateEdit.vue?vue&type=script&lang=js&"
export * from "./KaufschutzRateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports